module.exports = __webpack_public_path__ + "static/media/creek.55ced85c.png";